import { APP_ENV } from './constants.ts';

// Re-exported so `@/lib/utils` imports keep working: that `cn` knows the
// `@theme` tokens, so token classes merge correctly.
export { cn } from '@plato/ui/util/classes';

export const focusRing = [
    // base
    'outline-solid outline-offset-2 outline-0 focus-visible:outline-2',
    // outline color
    'outline-blue-500',
];

// Lang

export function isDev() {
    return process.env.NODE_ENV === 'development' || APP_ENV !== 'production';
}

const UUUID_REGEX = /^[0-9a-f]{8}\b-[0-9a-f]{4}\b-[0-9a-f]{4}\b-[0-9a-f]{4}\b-[0-9a-f]{12}/i;

export function validateUUID(uuid: unknown) {
    return typeof uuid === 'string' && UUUID_REGEX.test(uuid);
}
